import { WarningCircleIcon } from '@phosphor-icons/react'
import Styled from 'styled-components'
import { State } from '@hookstate/core'
import { AppButton, AppModal } from '@/shared/ui'
import { useTranslation } from 'react-i18next'

const Title = Styled.h2`
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 0.8rem;
  color: rgba(0, 0, 0, 0.85);
`
const Description = Styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
`

const Keypad = Styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 2.4rem;
  @media (max-width: 460px) {
    justify-content: center;
  }
`
type UnsavedChangesModalProps = {
  showModal: State<boolean, {}>
  action: () => void
}

const UnsavedChangesModal = ({ showModal, action }: UnsavedChangesModalProps) => {
  const { t } = useTranslation()
  const widthInPixels: number = 456

  return (
    <AppModal
      open={showModal.get()}
      mask={true}
      onCancel={() => showModal.set(false)}
      width={widthInPixels}
      footer={null}
      closable={true}
      centered
      styles={{
        mask: { zIndex: 10001000, background: 'rgba(0,0,0,0.45)' },
        body: { display: 'flex', flexDirection: 'column' },
        container: { padding: '2.4rem 2rem' }
      }}
    >
      <div style={{ display: 'flex' }}>
        <WarningCircleIcon style={{ color: '#FAAD14', fontSize: '18px' }} />
        <article style={{ marginLeft: '1.6rem' }}>
          <Title>{t('roles-permissions.unsaved-changes-title')}</Title>
          <Description>{t('roles-permissions.unsaved-changes-description')}</Description>
        </article>
      </div>
      <Keypad>
        <AppButton style={{ color: 'black' }} onClick={() => showModal.set(false)}>
          {t('cancel')}
        </AppButton>
        <AppButton variant='primary' style={{ marginLeft: '10px' }} onClick={() => action()}>
          {t('roles-permissions.save-and-next')}
        </AppButton>
      </Keypad>
    </AppModal>
  )
}

export { UnsavedChangesModal }
